(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["climai-booking"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.cbook[id]');
  sections.forEach(function (section) {
    var isEditor = document.documentElement.classList.contains('shopify-design-mode')
      || (window.Shopify && window.Shopify.designMode);

    var revealEls = section.querySelectorAll('[data-cbook-reveal]');
    var stepEls   = section.querySelectorAll('.cbook__step');

    if (isEditor) {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
      stepEls.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      });
    }, { threshold: 0.12 });

    revealEls.forEach(function (el) { obs.observe(el); });
    stepEls.forEach(function (el) { obs.observe(el); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["climai-booking2"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.cbook2[id]');
  sections.forEach(function (section) {
    var isEditor = document.documentElement.classList.contains('shopify-design-mode')
      || (window.Shopify && window.Shopify.designMode);

    var revealEls = section.querySelectorAll('[data-cbook2-reveal]');
    var stepEls   = section.querySelectorAll('.cbook2__step');

    if (isEditor) {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
      stepEls.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      });
    }, { threshold: 0.12 });

    revealEls.forEach(function (el) { obs.observe(el); });
    stepEls.forEach(function (el) { obs.observe(el); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["climai-booking3"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.cbook2[id]');
  sections.forEach(function (section) {
    var isEditor = document.documentElement.classList.contains('shopify-design-mode')
      || (window.Shopify && window.Shopify.designMode);

    var revealEls = section.querySelectorAll('[data-cbook2-reveal]');
    var stepEls   = section.querySelectorAll('.cbook2__step');

    if (isEditor) {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
      stepEls.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      });
    }, { threshold: 0.12 });

    revealEls.forEach(function (el) { obs.observe(el); });
    stepEls.forEach(function (el) { obs.observe(el); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["climai-hero-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  var isEditor = document.documentElement.classList.contains('shopify-design-mode')
    || (window.Shopify && window.Shopify.designMode);
  var els = document.querySelectorAll('[data-chv2-reveal]');
  if (isEditor) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-visible');
      obs.unobserve(e.target);
    });
  }, { threshold: 0.08 });
  els.forEach(function (el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["climai-pro-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Si el envio vuelve con errores, llevamos el foco al resumen. */
  var box = document.getElementById('ProFormErrors');
  if (box) { box.focus(); box.scrollIntoView({ block: 'center' }); }

  /* Un unico evento project_form_start la primera vez que se toca el formulario. */
  var form = document.querySelector('.pro-form__el');
  if (!form || form.dataset.proStarted) return;
  form.addEventListener('focusin', function once() {
    form.dataset.proStarted = '1';
    if (window.climaiTrack) window.climaiTrack('project_form_start', { label: 'formulario' });
    form.removeEventListener('focusin', once);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["climai-pro-header"]) return;
  try {
    
(function () {
  var openBtn = document.querySelector('[data-pro-drawer-open]');
  var drawer  = document.querySelector('[data-pro-drawer]');
  if (!openBtn || !drawer) return;

  var closeBtn = drawer.querySelector('[data-pro-drawer-close]');
  var lastFocus = null;

  function focusables() {
    return Array.prototype.slice.call(drawer.querySelectorAll('a[href], button:not([disabled])'))
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function open() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var f = focusables();
    if (f.length) f[0].focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    drawer.hidden = true;
    openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);

  /* TODOS los enlaces del cajon lo cierran, no solo los que llevan
     data-pro-drawer-link. El CTA "Enviar proyecto" no tenia ese atributo y era
     el unico elemento del menu movil que dejaba el cajon abierto: la pagina si
     saltaba al formulario, pero el usuario seguia viendo el menu encima y
     concluia, con razon, que el boton no hacia nada. Con `a[href]` cualquier
     enlace que se anada aqui en el futuro queda cubierto sin acordarse del
     atributo. */
  Array.prototype.forEach.call(drawer.querySelectorAll('a[href]'), function (a) {
    a.addEventListener('click', close);
  });

  var mq = window.matchMedia('(min-width: 1024px)');
  if (mq.addEventListener) {
    mq.addEventListener('change', function (e) { if (e.matches && !drawer.hidden) close(); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-postventa"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('.cp-landing');
  roots.forEach(function(root){
    if (root.dataset.cpInit) return;
    root.dataset.cpInit = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isEditor = window.Shopify && window.Shopify.designMode;

    if (!reduce && !isEditor && 'IntersectionObserver' in window){
      root.classList.add('cp-reveal-ready');
      root.querySelectorAll('[data-stagger]').forEach(function(g){
        Array.prototype.forEach.call(g.children, function(c,i){ c.style.transitionDelay = (i*90)+'ms'; });
      });
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold:0.15, rootMargin:'0px 0px -8% 0px' });
      root.querySelectorAll('[data-reveal],[data-stagger]').forEach(function(el){ io.observe(el); });
    }

    var sticky = root.querySelector('[data-cp-sticky]');
    var hero = root.querySelector('.cp-hero');
    if (sticky && hero && 'IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        es.forEach(function(e){ sticky.classList.toggle('is-visible', !e.isIntersecting); });
      }, { threshold:0 }).observe(hero);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-visita-tecnica"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('.cp-landing');
  roots.forEach(function(root){
    if (root.dataset.cpInit) return;
    root.dataset.cpInit = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isEditor = window.Shopify && window.Shopify.designMode;

    if (!reduce && !isEditor && 'IntersectionObserver' in window){
      root.classList.add('cp-reveal-ready'); // a partir de aquí los elementos parten ocultos
      root.querySelectorAll('[data-stagger]').forEach(function(g){
        Array.prototype.forEach.call(g.children, function(c,i){ c.style.transitionDelay = (i*90)+'ms'; });
      });
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold:0.15, rootMargin:'0px 0px -8% 0px' });
      root.querySelectorAll('[data-reveal],[data-stagger]').forEach(function(el){ io.observe(el); });
    }

    var sticky = root.querySelector('[data-cp-sticky]');
    var hero = root.querySelector('.cp-hero');
    if (sticky && hero && 'IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        es.forEach(function(e){ sticky.classList.toggle('is-visible', !e.isIntersecting); });
      }, { threshold:0 }).observe(hero);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
